import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import { Layout } from "antd";
import Logo from "../../images/pin_logo.png";
import "react-toastify/dist/ReactToastify.css";
import CircleMenu from "../../views/CircleMenu/MainCircleMenu";
import "./dineInStyle.scss";
import Area from "../../components/pop-up-menu/Area/";
import ProductsMenu from "../../components/pop-up-menu/Products/";

const { Content } = Layout;

const DineInLayout = ({ children, noNavbar, noFooter }) => (
  <Layout>
    <Container className="layout" fluid>
      <ToastContainer />
      <Row gutter={24}>
        <Col span={24} className="main-content" tag="main">
          <Content>
            <Row gutter={24}>
              <Col span={10} align="left">
                <Row gutter={16}>
                  <Col span={2}>
                    <img src={Logo} width="30%" alt="logo" />
                  </Col>
                  <Col span={22} className="user-details">
                    <p>User: Ahmed Mohamed</p>
                    <small>Login Time: 20/10/2020 16:30:22</small>
                  </Col>
                </Row>
              </Col>
              <Col span={4}>
                <Area />
              </Col>
              <Col span={10} style={{ margin: "16px 0" }} align="right">
                <Link
                  to="/main"
                  onClick={() => {
                    localStorage.clear();
                  }}
                  className="red-rounded-button"
                  style={{ textDecoration: "none" }}
                >
                  <i className="material-icons">lock</i>{" "}
                  <span className="red-button-text">Lock out</span>
                </Link>
              </Col>
            </Row>
            <div className="site-layout-content">{children}</div>
          </Content>
        </Col>
      </Row>
      <ProductsMenu />
      <CircleMenu auth={() => this.navigate()} />
    </Container>
  </Layout>
);

DineInLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

DineInLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default DineInLayout;
